module.exports = __webpack_public_path__ + "static/media/Pile_of_Coins@3x.c860c3b5.png";